<template>
  <v-container class="about-wrapper">
    <!-- Encabezado -->
    <div class="about-header">
      <h2 class="about-title">Sobre <span class="highlight">Nosotros</span></h2>
      <p class="about-subtitle">Expertos en energía renovable comprometidos con un futuro sostenible</p>
      <v-divider class="divider"></v-divider>
    </div>

    <!-- Contenido principal -->
    <v-row class="about-content" align="center">
      <v-col cols="12" md="6" class="about-image-col">
        <div class="image-container">
          <img
              :src="require('@/assets/galeria/1.jpg')"

              alt="Nuestro equipo trabajando en energía renovable"
              class="about-image"
              width="600"
              height="400"
              loading="eager"
          >
        </div>
      </v-col>

      <v-col cols="12" md="6" class="about-text-col">
        <h3 class="about-mission-title">Nuestra Misión</h3>
        <p class="about-mission-text">
          Somos una empresa de base tecnológica con la finalidad de
          comerciar productos y servicios con la mas alta calidad
          en el uso eficiente de los portadores energéticos y las energías renovables.
        </p>
        <h3 class="about-mission-title">Nuestra Visión</h3>
        <p class="about-mission-text">
          Generalizar nuestros productos y servicios en los mercados del sur de los Estados Unidos de America,
          Centro America y el Caribe.
        </p>

        <h3 class="about-values-title">Nuestros Valores</h3>
        <ul class="about-values-list">
          <li v-for="(value, index) in values" :key="index" class="about-value-item">
            <v-icon color="primary" class="value-icon">mdi-check-circle</v-icon>
            <span class="value-text">{{ value }}</span>
          </li>
        </ul>

        <div class="about-stats">
          <v-row>
            <v-col
                v-for="(stat, index) in stats"
                :key="index"
                cols="6"
                sm="3"
                class="stat-col"
            >
              <div class="stat-card">
                <div class="stat-number">{{ stat.number }}</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Nosotros',
  data() {
    return {
      values: [
        'Sostenibilidad ambiental',
        'Innovación tecnológica',
        'Transparencia y honestidad',
        'Excelencia en servicio',
        'Compromiso con el cliente',
        'Desarrollo comunitario'
      ],
      stats: [
        { number: '10+', label: 'Años de experiencia' },
        { number: '30+', label: 'Proyectos Diseñados y \nEjecutados' },
        { number: '95%', label: 'Clientes satisfechos' },
        { number: '24/7', label: 'Soporte técnico' }
      ]
    }
  }
}
</script>

<style scoped>
/* Estilos base */
.about-wrapper {
  max-width: 1400px;
  padding: 80px 24px;
  margin: 0 auto;
  background-color: #ffffff;
}

.about-header {
  text-align: center;
  margin-bottom: 60px;
}

.about-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0C594B;
  margin-bottom: 16px;
  line-height: 1.2;
}

.highlight {
  color: #0A9A8A;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background-color: rgba(10, 154, 138, 0.2);
  z-index: -1;
}

.about-subtitle {
  font-size: 1.1rem;
  color: #555;
  max-width: 600px;
  margin: 0 auto 24px;
}

.divider {
  width: 100px;
  height: 3px;
  background-color: #0A9A8A;
  margin: 0 auto;
  opacity: 1;
}

/* Contenedor de imagen optimizado */
.image-container {
  width: 100%;
  max-width: 600px;
  height: 400px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
}

.about-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* Sección de texto */
.about-text-col {
  padding: 24px;
}

.about-mission-title {
  font-size: 1.8rem;
  color: #0C594B;
  margin-bottom: 16px;
  font-weight: 600;
}

.about-mission-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 32px;
}

.about-values-title {
  font-size: 1.5rem;
  color: #0C594B;
  margin-bottom: 16px;
  font-weight: 600;
}

.about-values-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 40px;
}

.about-value-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.value-icon {
  margin-right: 12px;
  font-size: 1.5rem;
}

.value-text {
  font-size: 1rem;
  color: #555;
}

/* Estadísticas */
.about-stats {
  margin-top: 40px;
}

.stat-card {
  text-align: center;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-top: 4px solid #0A9A8A;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #0C594B;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
}

/* Responsive */
@media (max-width: 960px) {
  .image-container {
    height: 350px;
  }

  .about-mission-title {
    font-size: 1.5rem;
  }

  .about-values-title {
    font-size: 1.3rem;
  }
}

@media (max-width: 600px) {
  .about-wrapper {
    padding: 40px 16px;
  }

  .about-title {
    font-size: 1.8rem;
  }

  .image-container {
    height: 250px;
    margin-bottom: 24px;
  }

  .stat-number {
    font-size: 1.5rem;
  }

  .stat-label {
    font-size: 0.8rem;
  }
}
</style>